import { useState } from "react";
import { motion } from "framer-motion";
import { track, EVENTS } from "@/lib/analytics";

const EASE = [0.16, 1, 0.3, 1];

export default function TieBreak({ tieBreak, tied, onResolve }) {
    const [picked, setPicked] = useState(null);

    const choose = (key) => {
        if (picked) return;
        setPicked(key);
        track(EVENTS.QUESTION_ANSWERED, { question: "tie-break", option: key });
        setTimeout(() => onResolve(key), 340);
    };

    return (
        <div className="flex flex-1 flex-col justify-center pb-6">
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: EASE }}
            >
                <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-celestial-gold">
                    {tieBreak.header}
                </p>
                <h1
                    data-testid="tie-break-header"
                    className="mt-3 font-display text-[clamp(1.6rem,6.5vw,2.3rem)] leading-snug text-slate-100"
                >
                    {tieBreak.headerAccent}
                </h1>
                <p className="mt-4 text-[15px] leading-relaxed text-slate-400">
                    {tieBreak.subtext}
                </p>
            </motion.div>

            <div
                role="radiogroup"
                aria-label="Tie-break choice"
                className="mt-6 flex flex-col gap-3"
            >
                {tied.map((p, i) => {
                    const active = picked === p.key;
                    return (
                        <motion.button
                            key={p.key}
                            type="button"
                            role="radio"
                            aria-checked={active}
                            onClick={() => choose(p.key)}
                            data-testid={`tie-break-option-${p.key.toLowerCase()}`}
                            initial={{ opacity: 0, y: 16 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.1 + i * 0.07, duration: 0.4, ease: EASE }}
                            className={`flex min-h-[64px] items-center gap-4 rounded-2xl border px-5 py-4 text-left transition-all duration-200 ${
                                active
                                    ? "border-celestial-gold bg-celestial-gold/10 shadow-[0_0_30px_rgba(217,179,108,0.12)]"
                                    : "border-white/10 bg-white/[0.03] hover:border-celestial-blue/50 hover:bg-white/[0.06] active:scale-[0.99]"
                            }`}
                        >
                            <span
                                className={`grid h-7 w-7 shrink-0 place-items-center rounded-full border font-mono text-[10px] ${
                                    active
                                        ? "border-celestial-gold text-celestial-gold"
                                        : "border-white/20 text-slate-500"
                                }`}
                            >
                                {String.fromCharCode(65 + i)}
                            </span>
                            <span className="text-[15px] leading-snug text-slate-100 sm:text-base">
                                {tieBreak.statements[p.key]}
                            </span>
                        </motion.button>
                    );
                })}
            </div>
        </div>
    );
}
